import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import estilos from "../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SolicitudesComponent from "./SolicitudesComponent";
import SolicitudesFC09Component from "./SolicitudesFC09Component";

import { useDispatch, useSelector } from "react-redux";
import { obtenerTodasLasSolicitudesWithStatusEnviado } from "../../../redux/AtencionAClienteDucks";
import { Tab, Tabs } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import {
  DataGrid,
  GridToolbarQuickFilter,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 0.5,
        pb: 0,
        textAlign: "right",
      }}
    >
      {/*<GridToolbarFilterButton Title='Filtro'/>*/}
      <GridToolbarQuickFilter />
    </Box>
  );
}
function TabsSolicitudesComponent(props) {
  const dispatch = useDispatch();

  const [tabUno, setTabUno] = React.useState(true);
  const [tabDos, setTabDos] = React.useState(false);
  const [tabTres, setTabTres] = React.useState(false);
  const [tabCuatro, setTabCuatro] = React.useState(false);
  const [tabCinco, setTabCinco] = React.useState(false);
  const [tabSeis, setTabSeis] = React.useState(false);
  const [tabSiete, setTabSiete] = React.useState(false);
  const [tabOcho, setTabOcho] = React.useState(false);
  const [tabNueve, setTabNueve] = React.useState(false);
  const [tabDiez, setTabDiez] = React.useState(false);

  const [solicitudes, setSolicitudes] = React.useState([]);

  const setearValores = (tabNumber) => {
    setTabUno(tabNumber === 1);
    setTabDos(tabNumber === 2);
    setTabTres(tabNumber === 3);
    setTabCuatro(tabNumber === 4);
    setTabCinco(tabNumber === 5);
    setTabSeis(tabNumber === 6);
    setTabSiete(tabNumber === 7);
    setTabOcho(tabNumber === 8);
    setTabNueve(tabNumber === 9);
    setTabDiez(tabNumber === 10);
  };

  React.useEffect(() => {
    dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 })).then(
      (res) => {
        console.log(res.data.data);
        setSolicitudes(res.data.data);
      }
    );
  }, []);

  const rows = [];

  let columns = [
    
    {
        field: "folio",
        headerAlign: "center",
        headerClassName: estilos.headerSolicitudes,
        headerName: "Folio",
        flex: .7,
        resizable: true,
      },
      {
        field: "nombre",
        headerAlign: "center",
        headerClassName: estilos.headerSolicitudes,
        headerName: "Nombre o razon social",
        flex: 1,
        resizable: true,
      },
      {
        field: "socio",
        headerAlign: "center",
        headerClassName: estilos.headerSolicitudes,
        headerName: "No. de socio",
        flex: .5,
        resizable: true,
      },
      {
        field: "eslabones",
        headerAlign: "center",
        headerClassName: estilos.headerSolicitudes,
        headerName: "Cadena Productiva",
        flex: 1,
        resizable: true,
      },
      {
        field: "estatus",
        headerAlign: "center",
        headerClassName: estilos.headerSolicitudes,
        headerName: "Estatus",
        flex: 1,
        resizable: true,
      },
      {
        field: "revisor",
        headerAlign: "center",
        headerClassName: estilos.headerSolicitudes,
        headerName: "Revisor UI",
        flex: 1,
        resizable: true,
      },
      {
        field: "accion",
        headerAlign: "center",
        headerClassName: estilos.headerSolicitudes,
        headerName: "Acciones",
        flex: 1,
        resizable: true,
      },
      
  ];

  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Fragment>
        <Box className="text-center mt-5">
          <TabContext value={value}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                backgroundColor: "white",
                borderRadius: "2rem",
                //marginLeft: "15%",
                width: "100%",
              }} className="center" >
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  "& button": {
                    color: "black",
                    borderRadius: "2rem",
                    width: "20%",
                    transition: "all 0.3s ease",
                  },
                  "& button:hover, & button.Mui-selected": {
                    transform: "scale(1.1)",
                  },
                  "& button.Mui-selected": {
                    backgroundColor: "rgb(14, 129, 60)",
                    color: "white",
                    fontSize: "15pt",
                  },
                }}
              >
                <Tab label="FC_01" value="1" />
                <Tab label="FC_09" value="2" />
                <Tab label="FC_31" value="3" />
                <Tab label="FC_33" value="4" />
                <Tab label="FC_34" value="5" />
                <Tab label="FC_35" value="6" />
                <Tab label="FC_36" value="7" />
                <Tab label="FC_41" value="8" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <div className="col-12 mt-1 ms-3 text-center">
                <div style={{ height: 600, width: "100%", color: "black" }}>
                  <DataGrid
                    // autoHeight={true}
                    rows={rows}
                    columns={columns}
                    pageSize={10}
                    components={{
                      Toolbar: QuickSearchToolbar,
                    }}
                    //sortModel={[{ field: 'FechaDecreación', sort: 'desc' }]}
                    //sortModel={[{ field: 'folio', sort: 'desc' }]}
                    //slots={{ toolbar: QuickSearchToolbar }}
                    initialState={{
                      sorting: {
                        sortModel: [{ field: "FechaDecreación", sort: "desc" }],
                      },
                    }}
                    //initialState={{ sorting: {  sortModel: [{ field: 'folio', sort: 'desc' }], }, }}

                    sx={{
                      boxShadow: 0,
                      color: "black",
                      border: 0,
                      "& .MuiDataGrid-cell": {
                        display: "block",
                        position: "relative",
                        textAlign: "center",
                      },
                    }}
                  />
                </div>
                {/**<SolicitudesComponent /> */}
              </div>
            </TabPanel>
            <TabPanel value="2">
              <SolicitudesFC09Component
                solicitudes={
                  solicitudes.fc_09_solicitudemicioncertificadonomexportacionyentregahologram
                }
                tipo={9}
              />
            </TabPanel>
            <TabPanel value="3">
              {/*<SolicitudesFC09Component
                solicitudes={solicitudes.fc_31_solicitudseguimiento}
                tipo={31}
              />*/}
            </TabPanel>
            <TabPanel value="4">
              {/*<SolicitudesFC09Component
                solicitudes={solicitudes.fc_33_solicitudenvasadonacional}
                tipo={30}
              />*/}
            </TabPanel>
            <TabPanel value="5">
              {/*<SolicitudesFC09Component
                solicitudes={
                  solicitudes.fc_34_notificacionsuspencionyreactivacion
                }
                tipo={34}
              />*/}
            </TabPanel>
            <TabPanel value="6">
              {/*<SolicitudesFC09Component
                solicitudes={solicitudes.fc_35_notificaciondeserviciosvarios}
                tipo={35}
              />*/}
            </TabPanel>
            <TabPanel value="7">
              {/*<SolicitudesFC09Component
                solicitudes={solicitudes.fc_36_solicituddeactualizacion}
                tipo={36}
              />*/}
            </TabPanel>
            <TabPanel value="8">
              {/*<SolicitudesFC09Component
                solicitudes={solicitudes.fc_41_solicitudparabebidasconmezcal}
                tipo={41}
              />*/}
            </TabPanel>
          </TabContext>
        </Box>

      {/*
            <div className={`row text-center ${estilos.tabsCuartoNivel} `}>
                <div className='col'>
                    <button onClick={() => setearValores(1)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabUno ? '#68813B' : 'transparent', color: tabUno ? 'white' : 'black' }}>FC-01</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(2)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabDos ? '#68813B' : 'transparent', color: tabDos ? 'white' : 'black' }}>FC-09</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(3)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabTres ? '#68813B' : 'transparent', color: tabTres ? 'white' : 'black' }}>FC-33</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(4)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabCuatro ? '#68813B' : 'transparent', color: tabCuatro ? 'white' : 'black' }} disabled>FC-31</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(5)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabCinco ? '#68813B' : 'transparent', color: tabCinco ? 'white' : 'black' }} disabled>FC-34</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(6)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabSeis ? '#68813B' : 'transparent', color: tabSeis ? 'white' : 'black' }} disabled>FC-35</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(7)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabSiete ? '#68813B' : 'transparent', color: tabSiete ? 'white' : 'black' }} disabled>FC-36</button>
                </div>
                <div className='col'>
                    <button onClick={() => setearValores(8)} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabOcho ? '#68813B' : 'transparent', color: tabOcho ? 'white' : 'black' }} disabled>FC-41</button>
                </div>
            </div>

            {
                tabUno ? (
                    <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                        <div className="col ">
                            <SolicitudesComponent />
                        </div>
                    </div>
                ) :
                    tabDos ? (
                        <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                            <SolicitudesFC09Component solicitudes={solicitudes.fc_09_solicitudemicioncertificadonomexportacionyentregahologram} tipo={9} />
                        </div>
                    ) :
                        tabTres ? (
                            <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                <SolicitudesFC09Component solicitudes={solicitudes.fc_33_solicitudenvasadonacional} tipo={30} />
                            </div>
                        ) :
                            tabCuatro ? (
                                <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                    <SolicitudesFC09Component solicitudes={solicitudes.fc_31_solicitudseguimiento} tipo={31} />
                                </div>
                            ) :
                                tabCinco ? (
                                    <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                        <SolicitudesFC09Component solicitudes={solicitudes.fc_34_notificacionsuspencionyreactivacion} tipo={34} />
                                    </div>
                                ) :
                                    tabSeis ? (
                                        <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                            <SolicitudesFC09Component solicitudes={solicitudes.fc_35_notificaciondeserviciosvarios} tipo={35} />
                                        </div>
                                    ) :
                                        tabSiete ? (
                                            <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                <SolicitudesFC09Component solicitudes={solicitudes.fc_36_solicituddeactualizacion} tipo={36} />
                                            </div>
                                        ) :
                                            tabOcho ? (
                                                <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                    <SolicitudesFC09Component solicitudes={solicitudes.fc_41_solicitudparabebidasconmezcal} tipo={41} />
                                                </div>
                                            ) :
                                                (<></>)
            }
        */}
    </Fragment>
  );
}

export default withRouter(TabsSolicitudesComponent);
